import { defineStore } from 'pinia';
import { setService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import i18n from '@/locales/index';
export const useConditionStore = defineStore('condition', {
  state: () => ({
    // entity所有字段
    entityFields: {}
  }),
  actions: {
    // 查询筛选条件
    getEntityFields(params) {
      this.entityFields = null;
      return new Promise((resolve, reject) => {
        setService
          .getEntitySettings(params)
          .then((res) => {
            if (res?.error) {
              Message.error(res.error?.msg);
              return;
            }
            console.log('res', res);
            const newEntityFields = { ...this.entityFields };
            newEntityFields[params.entity] = res.result;
            this.entityFields = newEntityFields;
            resolve(res);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('获取数据失败'));
            reject(err);
          });
      });
    },
    //处理如果是计算类型或者条件编码
    getEntityFieldsList(params) {
      this.entityFields = null;
      return new Promise((resolve, reject) => {
        setService
          .sysEntitySetting(params)
          .then((res) => {
            if (res?.error) {
              Message.error(res.error?.msg);
              return;
            }
            console.log('res', res);
            const newEntityFields = { ...this.entityFields };
            newEntityFields[params.entity] = res.result;
            this.entityFields = newEntityFields;
            resolve(res);
          })
          .catch((err) => {
            Message.error(err.message || err.statusText || i18n.global.t('获取数据失败'));
            reject(err);
          });
      });
    }
  }
});
export default useConditionStore;
